function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import React, { Fragment } from 'react';
import { getProductTypeById } from '@finect/front-resources/Products';
import { PercentLabel } from '../../Labels';
import { empty } from '../FundComparison/utils/empty';
import { getPlaceholdersQty, MIN_PRODUCTS } from '../FundComparison/utils/configs';
import { parseFields, reduceProductFields, getLabel, getCellTextAlign } from '../../Products/ProductsTable/utils';
import { DefaultComponent } from '../../Products/ProductsTable/ProductRow/DefaultComponent';
import { NoAvailableDataComponent } from '../../Products/ProductsTable/ProductRow/NoAvailableDataComponent';
import { fieldsByProductType } from '../../Products/fieldsByProductType';
import { ProductCell } from './ProductCell';
var transpose = function transpose(m) {
  return m[0].map(function (x, i) {
    return m.map(function (x) {
      return x[i];
    });
  });
};
var getSheetPath = function getSheetPath(productType, product) {
  return "/".concat(productType.slug, "/").concat(product.entity.alias);
};
export var getGenericRows = function getGenericRows(productType, products, inPill, theme) {
  var fieldsDef = fieldsByProductType.find(function (def) {
    return def.productType === productType.id;
  });
  var fields = fieldsDef.comparisonFields;
  var order = null;
  var emptyFeesRows = empty(getPlaceholdersQty(products, MIN_PRODUCTS)).map(function () {
    return React.createElement(PercentLabel, {
      key: "empty",
      value: null
    });
  });
  var fistColumnAsHeader = true;
  var parsedFields = parseFields(fields);
  var columnFields = reduceProductFields(parsedFields, productType.id);
  var columns = columnFields.map(function (item) {
    var label = getLabel(item, productType);
    var textAlign = getCellTextAlign(item);
    var id = item.id;
    return {
      id: id,
      params: {
        textAlign: textAlign
      },
      component: label,
      orderable: Boolean(item.mapCompare && item.compare)
    };
  });
  var rowsTest = products.map(function (model) {
    var product = model;
    var itProductType = getProductTypeById(product.subtype);
    var itColumnFields = reduceProductFields(parsedFields, itProductType.id);
    return itColumnFields.map(function (field, index) {
      var map = field.map,
        _field$defaultParams = field.defaultParams,
        defaultParams = _field$defaultParams === void 0 ? {} : _field$defaultParams,
        _field$props = field.props,
        props = _field$props === void 0 ? field.component ? function (_ref) {
          var value = _ref.value;
          return value;
        } : function (_ref2) {
          var value = _ref2.value;
          return {
            value: value
          };
        } : _field$props,
        _field$component = field.component,
        component = _field$component === void 0 ? DefaultComponent : _field$component,
        _field$type = field.type,
        type = _field$type === void 0 ? 'string' : _field$type,
        mapCompare = field.mapCompare,
        _field$tooltip = field.tooltip,
        tooltip = _field$tooltip === void 0 ? null : _field$tooltip;
      var params = _objectSpread(_objectSpread(_objectSpread({}, defaultParams), field.params), {}, {
        partner: theme.partner
      });
      var value = map ? map(product, params, model) : null;
      var properties = props({
        value: value,
        productType: productType,
        params: params,
        product: product
      });
      var Component = value ? component : NoAvailableDataComponent;
      var stickyColumn = fistColumnAsHeader && index === 0;
      var textAlign = params.textAlign || null;
      var tdProps = _objectSpread(_objectSpread({
        as: stickyColumn ? 'th' : 'td'
      }, _objectSpread({}, stickyColumn ? {
        scope: 'row'
      } : {})), {}, {
        textAlign: textAlign ? textAlign : ['number'].includes(type) ? 'right' : index === 0 ? 'left' : 'center',
        wrapValue: params.wrap || null
      });
      var ContentComponent = function ContentComponent() {
        return React.createElement(Fragment, null, React.createElement(Component, properties));
      };
      return {
        params: tdProps,
        component: React.createElement(ContentComponent, properties),
        _orderableValue: mapCompare && order && order.field === field.id && order.ordering === 'child' ? mapCompare(product, params, model, value) : null
      };
    });
  });
  var comparisonRows = rowsTest.length ? transpose(rowsTest) : [];
  var comparisonFirstEmptyRows = comparisonRows.map(function (row, index) {
    return [columns[index].component].concat(_toConsumableArray(row.map(function (_ref3) {
      var component = _ref3.component;
      return component;
    })));
  });
  var rows = [[''].concat(_toConsumableArray(products.map(function (product, index) {
    return React.createElement(ProductCell, {
      key: index,
      productType: productType,
      index: index + 1,
      getSheetPath: getSheetPath,
      product: product,
      onDeleteAction: null,
      minimal: true
    });
  })))].concat(_toConsumableArray(comparisonFirstEmptyRows));
  if (!inPill) {
    rows.map(function (fee) {
      return fee.push.apply(fee, _toConsumableArray(emptyFeesRows));
    });
  }
  return rows;
};